import { DomainFirstTypesError } from './namespace';

export const AsyncSchemaInSyncParsingError = DomainFirstTypesError.error('ASYNC_LOGIC');
